import React, { ReactNode } from "react";
import theme from "./theme";

const CardContainer = ({ children }) => (
    <div>
        {children}
        <style jsx>{`
             {
                display: flex;
                flex-flow: column nowrap;
                margin-right: -15px;
                margin-left: -15px;
                margin-bottom: 2rem;
            }

            :last-of-type {
                margin-bottom: 0;
            }

            @media (min-width: ${theme.breakpoint.md}) {
                 {
                    flex-flow: row wrap;
                }
            }

            @media (min-width: ${theme.breakpoint.lg}) {
                 {
                    flex-flow: row wrap;
                }
            }

            @media (min-width: ${theme.breakpoint.xl}) {
                 {
                    flex-flow: row wrap;
                }
            }
        `}</style>
    </div>
);

type Props = {
    children: ReactNode;
    background?;
};

const Card = ({ children, background }: Props) => (
    <div>
        {children}
        <style jsx>{`
             {
                background: ${background ? background : "none"};
                border: 1px solid ${theme.colour.gray300};
                box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05),
                    0 1px 1px 0 rgba(0, 0, 0, 0.05),
                    0 2px 1px -1px rgba(0, 0, 0, 0.05);
                -webkit-font-smoothing: antialiased;
            }
        `}</style>
    </div>
);

const CardBody = ({ children }) => (
    <div>
        {children}
        <style jsx>{`
             {
                padding: 1rem;
            }
        `}</style>
    </div>
);

const CardFooter = ({ children }) => <div>{children}</div>;

const CardTitle = ({ children }) => (
    <div>
        {children}
        <style jsx>{`
             {
                text-align: center;
                font-size: 1.1rem;
            }
        `}</style>
    </div>
);

export { CardContainer, Card, CardBody, CardFooter, CardTitle };
